import React from 'react';
import { Spinner as SpinnerClass } from 'spin.js';

export class Spinner extends React.Component {

  get opts() {
    return {
      lines: 10, // The number of lines to draw
      length: 15, // The length of each line
      width: 3, // The line thickness
      radius: 10, // The radius of the inner circle
      scale: .8, // Scales overall size of the spinner
      corners: 1, // Corner roundness (0..1)
      color: '#ffffff', // #rgb or #rrggbb or array of colors
      opacity: 0.05, // Opacity of the lines
      rotate: 0, // The rotation offset
      direction: 1, // 1: clockwise, -1: counterclockwise
      speed: 1, // Rounds per second
      trail: 60, // Afterglow percentage
      fps: 20, // Frames per second when using setTimeout() as a fallback in IE 9
      zIndex: 2e9, // The z-index (defaults to 2000000000)
      className: 'spinner', // The CSS class to assign to the spinner
      top: '50%', // Top position relative to parent
      left: '50%', // Left position relative to parent
      shadow: false, // Whether to render a shadow
      position: 'absolute' // Element positioning
    }
  }

  componentWillMount(){
    const opts = this.opts;

    if(this.props.opts){
      Object.keys(this.props.opts).forEach( key => {
        opts[key] = this.props.opts[key]
      });
    }

    this.spinner = new SpinnerClass(opts);
  }

  componentWillReceiveProps(nextProps){
    const opts = this.opts;

    if(nextProps.opts){
      if(this.props.opts){
        Object.keys(nextProps.opts).forEach( key => {
          opts[key] = nextProps.opts[key]
        });
      }
      this.spinner = new SpinnerClass(opts);
    }
  }

  componentWillUnmount() {
    this.spinner.stop();
  }

  render(){
    return <div ref={spinner => { this.spinner.spin(spinner); }} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/spinner/Spinner.js